import { useEffect } from 'react';

const INTERCOM_SELECTOR = 'iframe[name^="intercom-"]';
const NOTIFICATION_FRAME_SELECTOR = 'iframe[name="intercom-notification-stack-frame"]';
const HIDE_DELAY = 2000;

/**
 * Custom hook to hide Intercom UI elements
 * Hides existing Intercom iframes and observes for new notification frames
 */
export const useHideIntercom = () => {
  useEffect(() => {
    // Hide existing Intercom iframe
    const hideExistingIntercomFrame = () => {
      const iframe = document.querySelector<HTMLIFrameElement>(INTERCOM_SELECTOR);
      if (iframe) {
        iframe.style.display = 'none';
      }
    };

    // Hide notification frames that are dynamically added
    const hideNotificationFrames = () => {
      const frames = document.querySelectorAll<HTMLIFrameElement>(NOTIFICATION_FRAME_SELECTOR);
      
      frames.forEach((iframe) => {
        if (!iframe.dataset.autoHidden) {
          iframe.dataset.autoHidden = 'true';
          
          setTimeout(() => {
            iframe.style.display = 'none';
          }, HIDE_DELAY);
        }
      });
    };

    // Initialize by hiding existing frames
    hideExistingIntercomFrame();

    // Set up observer for dynamically added frames
    const observer = new MutationObserver(hideNotificationFrames);
    
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Cleanup function
    return () => {
      observer.disconnect();
    };
  }, []);
}; 
